import React from "react";

import { css } from "glamor";
import { Tabs as BaseTabs } from "antd";

import SafeHTML from "../SafeHTML";

const styles = {
    tabs: css({
        " .ant-tabs-tab": {
            backgroundColor: "rgba(0, 174, 239, 0.15) !important",
            border: "solid 1px rgba(0, 0, 0, 0.15) !important",
            paddingLeft: "30px !important",
            paddingRight: "30px !important",
        },
        " .ant-tabs-tab-active": {
            backgroundColor: "#FFF !important",
            color: "#1b75bc !important",
        },
    }),
};

const Tabs = ({
    tabs,
    style,
    onChange = () => {},
    activeKey = tabs[0].label,
    defaultActiveKey,
}) => {
    const activeKeyProp = defaultActiveKey
        ? { defaultActiveKey }
        : { activeKey };

    return (
        <BaseTabs
            {...css(styles.tabs, style)}
            type="card"
            onChange={onChange}
            {...activeKeyProp}
        >
            {tabs.map(tab => (
                <BaseTabs.TabPane key={tab.key || tab.label} tab={tab.label}>
                    {React.isValidElement(tab.content) ? (
                        tab.content
                    ) : (
                        <SafeHTML html={tab.content} />
                    )}
                </BaseTabs.TabPane>
            ))}
        </BaseTabs>
    );
};

export default Tabs;
